import { createI18n } from 'vue-i18n';

import en from './locales/en/index.js';

const messages = { en };

const i18n = createI18n({
  // Required for Composition API usage (useI18n) across the app.
  // Prevents vue-i18n unmount disposer errors in some setups.
  legacy: false,
  globalInjection: true,
  locale: 'en', // Default locale
  fallbackLocale: 'en', // Fallback locale
  messages,
});

export default i18n;
